<template>
  <a
    href="#"
    class="cat_link"
    @click.prevent="$emit('select:category', category.id)"
  >
    {{ $_translations.value[category.name] }}
  </a>
</template>

<script setup>
defineEmits(['select:category']);

defineProps({
  category: {
    type: Object,
    default: () => ({}),
  },
});
</script>
